// extracted by mini-css-extract-plugin
module.exports = {"TableContainer":"TableWrapper_TableContainer__1CcFD","TopBorder":"TableWrapper_TopBorder__KqK6_"};